export default __webpack_public_path__ + "static/media/shopify-section-4.422efa56.png";